import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import { base_url } from "Backend/api";

const ProductCard = ({
  product,
  onAddToCart,
  addingId,
  isMarketClosed = false,
  className = "",
  isLast = false,
}) => {
  const isLoading = addingId === product.id;

  const handleAddClick = (e) => {
    e?.stopPropagation();
    if (isLoading || isMarketClosed) return;
    onAddToCart?.(product);
  };

  return (
    <div
      className={`border border-[#D6D6D6] border-t-0 border-r-0 border-l-0 border-[1px] group ${
        isMarketClosed ? "cursor-not-allowed opacity-70" : "cursor-pointer"
      } ${className} ${!isLast ? "border-b" : "border-b-0"}`}
    >
      <div className="flex items-start gap-4 p-3 ">
        <div className="flex-1 min-w-0">
          <h3 className="text-[14px] md:text-lg font-medium text-foreground mb-2 line-clamp-1 font-[cairo]">
            {product?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mb-2  line-clamp-1">
            {product?.description}
          </p>

          <div className="flex items-center gap-1">
            <button
              onClick={handleAddClick}
              disabled={isLoading || isMarketClosed}
              className={`flex items-center justify-center w-7 h-7 rounded-full ${
                isLoading || isMarketClosed
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#00B200] text-primary-foreground"
              }`}
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <Icon name="Plus" size={14} color="currentColor" strokeWidth={3} />
              )}
            </button>
            <div className="flex items-center gap-2">
              <span className="text-[16px] md:text-xl font-bold text-[#00B200]">
                {product?.current_price} ل.س
              </span>
            </div>
          </div>
        </div>

        <div className="relative flex-shrink-0 w-20 h-20 md:w-28 md:h-28 rounded-[8px] overflow-hidden">
          <Image
            src={`${base_url}/storage/app/public/${product?.image}`}
            alt={product?.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </div>

  );
};

export default ProductCard;